import classNames from 'classnames';
import { Children } from 'react';

import { Divider } from '@revelio/ui';

import { useBrand } from '../shared/branding/brand-provider';
import styles from './GlobalTopRightContent.module.css';
import { FreeTrialAlertModal } from './trialUser/FreeTrialAlertModal';
import { useFreeTrialAlertModalState } from './trialUser/useFreeTrialAlertModalState';

const PoweredByRevelioLabsMark = () => (
  <span
    className={styles.poweredByLogo}
    role="img"
    aria-label="Powered by Revelio Labs"
  />
);

export const PoweredByRevelioLabsLogo = () => {
  const { clientName } = useBrand();

  if (clientName === 'default') return null;

  return (
    <a href="https://www.reveliolabs.com/" target="_blank" rel="noreferrer">
      <PoweredByRevelioLabsMark />
    </a>
  );
};

export const GlobalTopRightContent = ({
  children,
  showPoweredBy,
  className,
}: {
  children?: React.ReactNode;
  showPoweredBy?: boolean;
  className?: string;
}) => {
  const { showTrialChip, days, hours } = useFreeTrialAlertModalState();
  const { clientName } = useBrand();

  const showPoweredByLogo = (showPoweredBy ?? true) && clientName !== 'default';
  const hasTrailingContent = showTrialChip || Children.count(children) > 0;

  return (
    <div className={classNames(styles.root, className)}>
      {showPoweredByLogo && (
        <a href="https://www.reveliolabs.com/" target="_blank" rel="noreferrer">
          <PoweredByRevelioLabsMark />
        </a>
      )}
      {showPoweredByLogo && hasTrailingContent && (
        <Divider className={styles.poweredByDivider} orientation="vertical" />
      )}
      {showTrialChip && (
        <div>
          <FreeTrialAlertModal days={days} hours={hours} />
        </div>
      )}
      {Children.count(children) > 0 && <div>{children}</div>}
    </div>
  );
};
